<template>
  <ScaleBox :width="1679" :isScale="isbig">
    <div class="desk-wrapper index-container order-detail console-wrapper">
      <div class="flex mb10 static-tj-tab">
        <el-radio-group v-model="radio1" size="mini" @change="goAnchor">
          <el-radio-button label="1">统计</el-radio-button>
          <el-radio-button label="2">呼叫订单</el-radio-button>
          <el-radio-button label="3">机构统计</el-radio-button>
          <el-radio-button label="4">青少年信息</el-radio-button>
          <el-radio-button label="5">工作信息</el-radio-button>
        </el-radio-group>
        <!-- <el-button icon="el-icon-download"
                   size="mini"
                   type="primary">导出</el-button> -->
      </div>
      <div ref="scoll-page" style="overflow-y: auto;overflow-x:hidden"
        :style="{ height: isbig ? 'calc(100vh - 58px)' : 'calc(100vh - 244px)' }">
        <!-- <div class="df statis-item-wrapper"> -->
        <div ref="#anchor-1" v-if="statisticalTopData.totalCnt != undefined">
          <el-row :gutter="10" type="flex" justify="space-around">
            <el-col :span="24 / 5" :md="8">
              <div class="common-box item flex static-item h110">
                <div class="item-circle">
                  <el-avatar :size="52" shape="square" fit="contain" :src="`/img/bg/icon1.jpg`"></el-avatar>
                </div>
                <div class="item ml20 flex-one">
                  <div class="fs24 c0 num-family">{{ statisticalTopData.totalCnt }}</div>
                  <div class="c9 font-nowrap">总呼叫数</div>
                </div>
              </div>
            </el-col>
            <el-col :span="24 / 5" :md="8" :key="item">
              <div class="common-box item flex static-item h110">
                <div class="item-circle">
                  <el-avatar :size="52" shape="square" fit="contain" :src="`/img/bg/icon2.jpg`"></el-avatar>
                </div>
                <div class="item ml20 flex-one">
                  <div class="fs24 c0 num-family">{{ statisticalTopData.weekCnt }}</div>
                  <div class="c9 font-nowrap">新增呼叫数(当周)</div>
                </div>
              </div>
            </el-col>
            <el-col :span="24 / 5" :md="8" :key="item">
              <div class="common-box item flex static-item h110">
                <div class="item-circle">
                  <el-avatar :size="52" shape="square" fit="contain" :src="`/img/bg/icon3.jpg`"></el-avatar>
                </div>
                <div class="item ml20 flex-one">
                  <div class="fs24 c0 num-family">{{ statisticalTopData.jinanCnt }}</div>
                  <div class="c9 font-nowrap">全区服务机构数</div>
                </div>
              </div>
            </el-col>
            <el-col :span="24 / 5" :md="8" :key="item">
              <div class="common-box item flex static-item h110">
                <div class="item-circle">
                  <el-avatar :size="52" shape="square" fit="contain" :src="`/img/bg/icon4.jpg`"></el-avatar>
                </div>
                <div class="item ml20 flex-one">
                  <div class="fs24 c0 num-family">{{ statisticalTopData.totalDone }}</div>
                  <div class="c9 font-nowrap">已完成数</div>
                </div>
              </div>
            </el-col>
            <el-col :span="24 / 5" :md="8" :key="item">
              <div class="common-box item flex static-item h110">
                <div class="item-circle">
                  <el-avatar :size="52" shape="square" fit="contain" :src="`/img/bg/icon5.jpg`"></el-avatar>
                </div>
                <div class="item ml20 flex-one">
                  <div class="fs24 c0 num-family">{{ statisticalTopData.youngAmount }}</div>
                  <div class="c9 font-nowrap">全区青少年数量</div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="10" type="flex" justify="space-around">
            <el-col :span="24 / 5" :md="8" :key="item">
              <div class="common-box item flex static-item h110">
                <div class="item-circle">
                  <el-avatar :size="52" shape="square" fit="contain" :src="`/img/bg/icon6.jpg`"></el-avatar>
                </div>
                <div class="item ml20 flex-one">
                  <div class="fs24 c0 num-family">{{ statisticalTopData.totalUndo }}</div>
                  <div class="c9 font-nowrap">进行中订单数</div>
                </div>
              </div>
            </el-col>
            <el-col :span="24 / 5" :md="8" :key="item">
              <div class="common-box item flex static-item h110">
                <div class="item-circle">
                  <el-avatar :size="52" shape="square" fit="contain" :src="`/img/bg/icon7.jpg`"></el-avatar>
                </div>
                <div class="item ml20 flex-one">
                  <div class="fs24 c0 num-family">{{ statisticalTopData.totalDel }}</div>
                  <div class="c9 font-nowrap">服务终止数(SC)</div>
                </div>
              </div>
            </el-col>
            <el-col :span="24 / 5" :md="8" :key="item">
              <div class="common-box item flex static-item h110">
                <div class="item-circle">
                  <el-avatar :size="52" shape="square" fit="contain" :src="`/img/bg/icon9.jpg`"></el-avatar>
                </div>
                <div class="item ml20 flex-one">
                  <div class="fs24 c0 num-family">{{ statisticalTopData.curMonthCnt }}</div>
                  <div class="c9 font-nowrap">当月订单度增长数量</div>
                </div>
              </div>
            </el-col>
            <el-col :span="24 / 5" :md="8">
              <div class="common-box item flex static-item h110">
                <div class="item-circle">
                  <el-avatar :size="52" shape="square" fit="contain" :src="`/img/bg/icon8.jpg`"></el-avatar>
                </div>
                <div class="item ml20 flex-one">
                  <div class="fs24 c0 num-family">{{ statisticalTopData.lastMonthCnt }}%</div>
                  <div class="c9 font-nowrap">当月订单增长率(上月比)</div>
                </div>
              </div>
            </el-col>
            <el-col :span="24 / 5" :md="8" :key="item">
              <div class="common-box item flex static-item h110">
                <div class="item-circle">
                  <el-avatar :size="52" shape="square" fit="contain" :src="`/img/bg/icon10.jpg`"></el-avatar>
                </div>
                <div class="item ml20 flex-one">
                  <div class="fs24 c0 num-family">{{ statisticalTopData.lastYearCnt }}%</div>
                  <div class="c9 font-nowrap">当年订单增长率(上年比)</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <!-- </div> -->
        <div class="two-level-container" style="margin-top: 3px; display: flex" ref="#anchor-2">
          <div class="index-box lv2-box h100">
            <div class="lv2-header">
              <div class="tabs">
                <div class="tab" :class="{ act: orderIndex == 0 }" @click="clickOrderIndex(0)">
                  呼叫量
                </div>
                <div class="tab" :class="{ act: orderIndex == 1 }" @click="clickOrderIndex(1)">
                  完成量
                </div>
              </div>
              <div class="date-wrapper">
                <el-select class="yearOptionsClass" v-model="topYearValue" placeholder="请选择" @change="topYearValueWay">
                  <el-option v-for="item in YearOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <!-- <el-button icon="el-icon-download" size="mini" type="primary">导出</el-button>? -->
              </div>
            </div>
            <div class="lv2-body flex-one">
              <div class="body-left">
                <div class="lv2-title">统计数据</div>
                <div class="success-bar">
                  <bar ref="bar"></bar>
                </div>
              </div>
              <div class="body-right">
                <div class="lv2-title">涉案年龄段</div>
                <!-- <div class="lv2-title">年龄段分布</div> -->
                <agePieChart ref="agePieChart"></agePieChart>
                <!-- <div class="rank-container">
                            <div class="item" v-for="item in 7" :key="item">
                                <div class="name"><span class="ovh"><span class="dot" :class="{'act':item<3}">{{item}}</span>晋安区人民检察院{{item}}</span></div>
                                <div class="num num-family">323,234</div>
                            </div>
                        </div> -->
              </div>
            </div>
          </div>
        </div>
        <el-row type="flex" :gutter="10">
          <el-col :span="15" class="three-level-container">
            <div class="common-box flex-vertic w100">
              <div class="o-title border flex">
                <div>呼叫订单类型</div>
                <el-select class="yearOptionsClass" v-model="workTypeYearValue" placeholder="请选择"
                  @change="loadWorkTypeDataWay">
                  <el-option v-for="item in YearOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="console-item">
                <div class="item ml20 mr20" style="height: 200px">
                  <orderChart title="综合援助" :chartData="workTypeData.zhyz" :breatheTyleSum="workTypeData.zhyzCnt">
                  </orderChart>
                </div>
                <div class="item ml20 mr20" style="height: 200px">
                  <orderChart title="思政教导" :chartData="workTypeData.szjd" :breatheTyleSum="workTypeData.szjdCnt">
                  </orderChart>
                </div>
                <div class="item ml20 mr20" style="height: 200px">
                  <orderChart title="政策救助" :chartData="workTypeData.zzjz" :breatheTyleSum="workTypeData.zzjzCnt">
                  </orderChart>
                </div>
              </div>
              <!-- <div class="echart-wrapper">
              <div class="echart-box">
                <div>总订单数<i class="el-icon-question"></i></div>
                <div class="num num-family">
                  16,321
                  <span class="sqr"
                    >17.1<i class="el-icon-caret-bottom green"></i
                  ></span>
                </div>
                <div class="echart" style="height: 150px">
                  <base-line1 :chartData="chartData"></base-line1>
                </div>
              </div>
              <div class="echart-box">
                <div>等待流转派单时间<i class="el-icon-question"></i></div>
                <div class="num num-family">
                  08<span class="fs14">时</span>07<span class="fs14">分</span
                  ><span class="sqr"
                    >17.1<i class="el-icon-caret-top red"></i
                  ></span>
                </div>
                <div class="echart" style="height: 150px">
                  <base-line1></base-line1>
                </div>
              </div>
            </div> -->
              <!-- <div class="o-title border mt20">呼叫量趋势</div> -->
              <!-- <div class="o-title border flex mt20">
              <div>呼叫量趋势</div>
              <div class="c9">更多</div>
            </div>
            <div class="flex-one">
              <linechart></linechart>
            </div> -->
            </div>
          </el-col>
          <el-col :span="9" class="flex-vertic">
            <div class="common-box mt10">
              <div class="o-title border">计划类型占比(前三类)
                <el-select class="yearOptionsClass" v-model="planWorkTypeYearValue" placeholder="请选择"
                  @change="loadBreatheTyleDataWay">
                  <el-option v-for="item in YearOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="console-item" v-if="planWorkTypeShow">
                <div class="item ml20 mr20" style="height: 200px">
                  <circlechart ref="circlechart1" v-if="planWorkTypeData.data[0] != undefined"></circlechart>
                </div>
                <div class="item ml20 mr20" style="height: 200px">
                  <circlechart ref="circlechart2" v-if="planWorkTypeData.data[1] != undefined"></circlechart>
                </div>
                <div class="item ml20 mr20" style="height: 200px">
                  <circlechart ref="circlechart3" v-if="planWorkTypeData.data[2] != undefined"></circlechart>
                </div>
              </div>
              <div style="height: 200px;display: flex;justify-content: center;align-items: center;" v-else>
                <div class="avue-empty">
                  <div class="avue-empty__image" style="height: 50px;"><img
                      src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxKSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxlbGxpcHNlIGZpbGw9IiNGNUY1RjUiIGN4PSIzMiIgY3k9IjMzIiByeD0iMzIiIHJ5PSI3Ii8+CiAgICA8ZyBmaWxsLXJ1bGU9Im5vbnplcm8iIHN0cm9rZT0iI0Q5RDlEOSI+CiAgICAgIDxwYXRoIGQ9Ik01NSAxMi43Nkw0NC44NTQgMS4yNThDNDQuMzY3LjQ3NCA0My42NTYgMCA0Mi45MDcgMEgyMS4wOTNjLS43NDkgMC0xLjQ2LjQ3NC0xLjk0NyAxLjI1N0w5IDEyLjc2MVYyMmg0NnYtOS4yNHoiLz4KICAgICAgPHBhdGggZD0iTTQxLjYxMyAxNS45MzFjMC0xLjYwNS45OTQtMi45MyAyLjIyNy0yLjkzMUg1NXYxOC4xMzdDNTUgMzMuMjYgNTMuNjggMzUgNTIuMDUgMzVoLTQwLjFDMTAuMzIgMzUgOSAzMy4yNTkgOSAzMS4xMzdWMTNoMTEuMTZjMS4yMzMgMCAyLjIyNyAxLjMyMyAyLjIyNyAyLjkyOHYuMDIyYzAgMS42MDUgMS4wMDUgMi45MDEgMi4yMzcgMi45MDFoMTQuNzUyYzEuMjMyIDAgMi4yMzctMS4zMDggMi4yMzctMi45MTN2LS4wMDd6IiBmaWxsPSIjRkFGQUZBIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"
                      alt=""></div>
                  <p class="avue-empty__desc">暂无数据</p>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row type="flex" :gutter="10">
          <el-col :span="24" class="three-level-container">
            <div class="common-box flex-vertic w100">
              <div class="o-title border flex mt20">
                <div>总呼叫量趋势</div>
                <el-select class="yearOptionsClass" v-model="monthTrendYearValue" placeholder="请选择"
                  @change="loadMonthTrendDataWay">
                  <el-option v-for="item in YearOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="flex-one" style="height: 200px">
                <linechart ref="linechart" style="height: 200px"></linechart>
              </div>
            </div>
          </el-col>
        </el-row>
        <div ref="#anchor-3">
          <el-row type="flex" :gutter="10">
            <el-col :span="24" class="three-level-container">
              <div class="common-box flex-vertic w100">
                <div class="o-title border flex mt20">
                  <div>机构统计数据</div>
                  <el-select class="yearOptionsClass" v-model="YearValue" placeholder="请选择" @change="YearValueWay">
                    <el-option v-for="item in YearOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="flex-one" style="height: 240px">
                  <jgbar style="height: 240px"></jgbar>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row type="flex" :gutter="10">
            <el-col :span="24" class="three-level-container">
              <div class="common-box flex-vertic w100">
                <div class="o-title border flex mt20">
                  <div>救助地域分布</div>
                  <el-select class="yearOptionsClass" v-model="regionSalvageYearValue" placeholder="请选择"
                    @change="loadRegionSalvageDataWay">
                    <el-option v-for="item in YearOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="flex-one" style="height: 200px">
                  <rescueRegionChar ref="rescueRegionChar" style="height: 200px"></rescueRegionChar>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div ref="#anchor-4">
          <el-row type="flex" :gutter="10">
            <el-col :span="24" class="three-level-container">
              <div class="common-box flex-vertic w100">
                <div style="font-size: 16px; font-weight: bold">青少年信息</div>
                <div class="o-title border flex mt20">
                  <div>涉案时间(按月)</div>
                  <div style="display: inline-flex;">
                    <el-select class="yearOptionsClass" v-model="crimeTimeYearValue" placeholder="请选择"
                      @change="loadCrimeTimeDataWay">
                      <el-option v-for="item in YearOptions" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                    <el-select class="monthOptionsClass" v-model="monthValue" placeholder="请选择"
                      @change="loadCrimeTimeDataWay">
                      <el-option v-for="item in monthOptions" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-one" style="height: 200px" v-if="crimeTimeIf">
                  <timeChar ref="timeChar" style="height: 200px"></timeChar>
                </div>
                <div style="height: 220px;display: flex;justify-content: center;align-items: center;" v-else>
                  <div class="avue-empty">
                    <div class="avue-empty__image" style="height: 50px;"><img
                        src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxKSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxlbGxpcHNlIGZpbGw9IiNGNUY1RjUiIGN4PSIzMiIgY3k9IjMzIiByeD0iMzIiIHJ5PSI3Ii8+CiAgICA8ZyBmaWxsLXJ1bGU9Im5vbnplcm8iIHN0cm9rZT0iI0Q5RDlEOSI+CiAgICAgIDxwYXRoIGQ9Ik01NSAxMi43Nkw0NC44NTQgMS4yNThDNDQuMzY3LjQ3NCA0My42NTYgMCA0Mi45MDcgMEgyMS4wOTNjLS43NDkgMC0xLjQ2LjQ3NC0xLjk0NyAxLjI1N0w5IDEyLjc2MVYyMmg0NnYtOS4yNHoiLz4KICAgICAgPHBhdGggZD0iTTQxLjYxMyAxNS45MzFjMC0xLjYwNS45OTQtMi45MyAyLjIyNy0yLjkzMUg1NXYxOC4xMzdDNTUgMzMuMjYgNTMuNjggMzUgNTIuMDUgMzVoLTQwLjFDMTAuMzIgMzUgOSAzMy4yNTkgOSAzMS4xMzdWMTNoMTEuMTZjMS4yMzMgMCAyLjIyNyAxLjMyMyAyLjIyNyAyLjkyOHYuMDIyYzAgMS42MDUgMS4wMDUgMi45MDEgMi4yMzcgMi45MDFoMTQuNzUyYzEuMjMyIDAgMi4yMzctMS4zMDggMi4yMzctMi45MTN2LS4wMDd6IiBmaWxsPSIjRkFGQUZBIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"
                        alt=""></div>
                    <p class="avue-empty__desc">暂无数据</p>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row type="flex" :gutter="10">
            <el-col :span="15" class="three-level-container">
              <div class="common-box flex-vertic w100">
                <!-- <div class="o-title border flex">
                  <div>
                    用户在线数据
                    <span>(1234)</span>
                  </div>
                </div>
                <div class="flex-one">
                  <onlineChar></onlineChar>
                </div> -->
                <div class="o-title border flex mt20">
                  <div>五类青少年分布</div>
                  <el-select class="yearOptionsClass" v-model="regionTypeYearValue" placeholder="请选择"
                    @change="loadAdolescentKindDataWay">
                    <el-option v-for="item in YearOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="flex-one">
                  <fiveChart ref="fiveChart"></fiveChart>
                </div>
                <!-- <div class="o-title border flex mt20">
                  <div>参与机构穿透图</div>
                </div>
                <div class="flex-one"
                     style="height：250px;">
                  <testChart style="height：250px;"></testChart>
                </div> -->
                <div class="o-title border flex mt20">
                  <div>
                    案件类型
                    <!-- <span>(44)</span> -->

                  </div>
                  <div>
                    <el-select class="yearOptionsClass" v-model="youngCrimeTypeYearValue" placeholder="请选择"
                      @change="loadYoungCrimeTypeDataWay">
                      <el-option v-for="item in YearOptions" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-one">
                  <case-type-chat ref="caseTypeChat"></case-type-chat>
                </div>
                <div class="o-title border flex mt20">
                  <div>涉案特定场所</div>
                  <el-select class="yearOptionsClass" v-model="placeTypeYearValue" placeholder="请选择" @change="loadPlaceTypeDataWay">
                    <el-option v-for="item in YearOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="flex-one">
                  <involvedPlaceChat ref="involvedPlaceChat"></involvedPlaceChat>
                </div>
                <div class="o-title border flex mt20">
                  <div>涉案家庭类型</div>
                  <el-select class="yearOptionsClass" v-model="householdTypeYearValue" placeholder="请选择" @change="loadHouseholdTypeDataWay">
                    <el-option v-for="item in YearOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="flex-one">
                  <involvedFamilyChat ref="involvedFamilyChat"></involvedFamilyChat>
                </div>
              </div>
            </el-col>
            <el-col :span="9" class="flex-vertic">
              <div class="common-box mt10">
                <div class="o-title border">法律法规意识认识程度
                  <el-select class="yearOptionsClass" v-model="lawRegulationsYearValue" placeholder="请选择"
                    @change="loadLawRegulationsDataWay">
                    <el-option v-for="item in YearOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="flex-one h220" v-if="lawRegulationsIf">
                  <monthOrganChart1 ref="monthOrganChart1" ></monthOrganChart1>
                </div>
                <div style="height: 220px;display: flex;justify-content: center;align-items: center;" v-else>
                  <div class="avue-empty">
                    <div class="avue-empty__image" style="height: 50px;"><img
                        src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxKSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxlbGxpcHNlIGZpbGw9IiNGNUY1RjUiIGN4PSIzMiIgY3k9IjMzIiByeD0iMzIiIHJ5PSI3Ii8+CiAgICA8ZyBmaWxsLXJ1bGU9Im5vbnplcm8iIHN0cm9rZT0iI0Q5RDlEOSI+CiAgICAgIDxwYXRoIGQ9Ik01NSAxMi43Nkw0NC44NTQgMS4yNThDNDQuMzY3LjQ3NCA0My42NTYgMCA0Mi45MDcgMEgyMS4wOTNjLS43NDkgMC0xLjQ2LjQ3NC0xLjk0NyAxLjI1N0w5IDEyLjc2MVYyMmg0NnYtOS4yNHoiLz4KICAgICAgPHBhdGggZD0iTTQxLjYxMyAxNS45MzFjMC0xLjYwNS45OTQtMi45MyAyLjIyNy0yLjkzMUg1NXYxOC4xMzdDNTUgMzMuMjYgNTMuNjggMzUgNTIuMDUgMzVoLTQwLjFDMTAuMzIgMzUgOSAzMy4yNTkgOSAzMS4xMzdWMTNoMTEuMTZjMS4yMzMgMCAyLjIyNyAxLjMyMyAyLjIyNyAyLjkyOHYuMDIyYzAgMS42MDUgMS4wMDUgMi45MDEgMi4yMzcgMi45MDFoMTQuNzUyYzEuMjMyIDAgMi4yMzctMS4zMDggMi4yMzctMi45MTN2LS4wMDd6IiBmaWxsPSIjRkFGQUZBIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"
                        alt=""></div>
                    <p class="avue-empty__desc">暂无数据</p>
                  </div>
                </div>
                <!-- <div class="o-title border">月机构活跃数</div>
                <div class="flex-one h220">
                  <monthOrganChart></monthOrganChart>
                </div> -->
                <div class="o-title border mt20">涉案青少年文化程度
                  <el-select class="yearOptionsClass" v-model="academicStageYearValue" placeholder="请选择"
                    @change="loadAcademicStageDataWay">
                    <el-option v-for="item in YearOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="flex-one h220" v-if="academicStageIf">
                  <cultureChart ref="cultureChart"></cultureChart>
                </div>
                <div style="height: 220px;display: flex;justify-content: center;align-items: center;" v-else>
                  <div class="avue-empty">
                    <div class="avue-empty__image" style="height: 50px;"><img
                        src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxKSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxlbGxpcHNlIGZpbGw9IiNGNUY1RjUiIGN4PSIzMiIgY3k9IjMzIiByeD0iMzIiIHJ5PSI3Ii8+CiAgICA8ZyBmaWxsLXJ1bGU9Im5vbnplcm8iIHN0cm9rZT0iI0Q5RDlEOSI+CiAgICAgIDxwYXRoIGQ9Ik01NSAxMi43Nkw0NC44NTQgMS4yNThDNDQuMzY3LjQ3NCA0My42NTYgMCA0Mi45MDcgMEgyMS4wOTNjLS43NDkgMC0xLjQ2LjQ3NC0xLjk0NyAxLjI1N0w5IDEyLjc2MVYyMmg0NnYtOS4yNHoiLz4KICAgICAgPHBhdGggZD0iTTQxLjYxMyAxNS45MzFjMC0xLjYwNS45OTQtMi45MyAyLjIyNy0yLjkzMUg1NXYxOC4xMzdDNTUgMzMuMjYgNTMuNjggMzUgNTIuMDUgMzVoLTQwLjFDMTAuMzIgMzUgOSAzMy4yNTkgOSAzMS4xMzdWMTNoMTEuMTZjMS4yMzMgMCAyLjIyNyAxLjMyMyAyLjIyNyAyLjkyOHYuMDIyYzAgMS42MDUgMS4wMDUgMi45MDEgMi4yMzcgMi45MDFoMTQuNzUyYzEuMjMyIDAgMi4yMzctMS4zMDggMi4yMzctMi45MTN2LS4wMDd6IiBmaWxsPSIjRkFGQUZBIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"
                        alt=""></div>
                    <p class="avue-empty__desc">暂无数据</p>
                  </div>
                </div>
                <div class="o-title border mt20">涉案青少年男女比例
                  <el-select class="yearOptionsClass" v-model="genderYearValue" placeholder="请选择"
                    @change="loadGenderDataWay">
                    <el-option v-for="item in YearOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="flex-one h220" v-if="genderIf">
                  <sexChart ref="sexChart"></sexChart>
                </div>
                <div style="height: 220px;display: flex;justify-content: center;align-items: center;" v-else>
                  <div class="avue-empty">
                    <div class="avue-empty__image" style="height: 50px;"><img
                        src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxKSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxlbGxpcHNlIGZpbGw9IiNGNUY1RjUiIGN4PSIzMiIgY3k9IjMzIiByeD0iMzIiIHJ5PSI3Ii8+CiAgICA8ZyBmaWxsLXJ1bGU9Im5vbnplcm8iIHN0cm9rZT0iI0Q5RDlEOSI+CiAgICAgIDxwYXRoIGQ9Ik01NSAxMi43Nkw0NC44NTQgMS4yNThDNDQuMzY3LjQ3NCA0My42NTYgMCA0Mi45MDcgMEgyMS4wOTNjLS43NDkgMC0xLjQ2LjQ3NC0xLjk0NyAxLjI1N0w5IDEyLjc2MVYyMmg0NnYtOS4yNHoiLz4KICAgICAgPHBhdGggZD0iTTQxLjYxMyAxNS45MzFjMC0xLjYwNS45OTQtMi45MyAyLjIyNy0yLjkzMUg1NXYxOC4xMzdDNTUgMzMuMjYgNTMuNjggMzUgNTIuMDUgMzVoLTQwLjFDMTAuMzIgMzUgOSAzMy4yNTkgOSAzMS4xMzdWMTNoMTEuMTZjMS4yMzMgMCAyLjIyNyAxLjMyMyAyLjIyNyAyLjkyOHYuMDIyYzAgMS42MDUgMS4wMDUgMi45MDEgMi4yMzcgMi45MDFoMTQuNzUyYzEuMjMyIDAgMi4yMzctMS4zMDggMi4yMzctMi45MTN2LS4wMDd6IiBmaWxsPSIjRkFGQUZBIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"
                        alt=""></div>
                    <p class="avue-empty__desc">暂无数据</p>
                  </div>
                </div>
                <div class="o-title border mt20">救助年龄分布
                  <el-select class="yearOptionsClass" v-model="ageSalvageYearValue" placeholder="请选择"
                    @change="loadAgeSalvageDataWay">
                    <el-option v-for="item in YearOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="flex-one h220" v-if="ageSalvageIf">
                  <agePieChart ref="agePieChart2"></agePieChart>
                </div>
                <div style="height: 220px;display: flex;justify-content: center;align-items: center;" v-else>
                  <div class="avue-empty">
                    <div class="avue-empty__image" style="height: 50px;"><img
                        src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxKSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxlbGxpcHNlIGZpbGw9IiNGNUY1RjUiIGN4PSIzMiIgY3k9IjMzIiByeD0iMzIiIHJ5PSI3Ii8+CiAgICA8ZyBmaWxsLXJ1bGU9Im5vbnplcm8iIHN0cm9rZT0iI0Q5RDlEOSI+CiAgICAgIDxwYXRoIGQ9Ik01NSAxMi43Nkw0NC44NTQgMS4yNThDNDQuMzY3LjQ3NCA0My42NTYgMCA0Mi45MDcgMEgyMS4wOTNjLS43NDkgMC0xLjQ2LjQ3NC0xLjk0NyAxLjI1N0w5IDEyLjc2MVYyMmg0NnYtOS4yNHoiLz4KICAgICAgPHBhdGggZD0iTTQxLjYxMyAxNS45MzFjMC0xLjYwNS45OTQtMi45MyAyLjIyNy0yLjkzMUg1NXYxOC4xMzdDNTUgMzMuMjYgNTMuNjggMzUgNTIuMDUgMzVoLTQwLjFDMTAuMzIgMzUgOSAzMy4yNTkgOSAzMS4xMzdWMTNoMTEuMTZjMS4yMzMgMCAyLjIyNyAxLjMyMyAyLjIyNyAyLjkyOHYuMDIyYzAgMS42MDUgMS4wMDUgMi45MDEgMi4yMzcgMi45MDFoMTQuNzUyYzEuMjMyIDAgMi4yMzctMS4zMDggMi4yMzctMi45MTN2LS4wMDd6IiBmaWxsPSIjRkFGQUZBIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"
                        alt=""></div>
                    <p class="avue-empty__desc">暂无数据</p>
                  </div>
                </div>
                <div class="o-title border mt20">涉案青少年户籍所在地比例
                  <el-select class="yearOptionsClass" v-model="provinceYearValue" placeholder="请选择" @change="loadProvinceDataWay">
                    <el-option v-for="item in YearOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="flex-one h220" v-if="provinceIf">
                  <registerChart ref="registerChart"></registerChart>
                </div>
                <div style="height: 220px;display: flex;justify-content: center;align-items: center;" v-else>
                  <div class="avue-empty">
                    <div class="avue-empty__image" style="height: 50px;"><img
                        src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxKSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxlbGxpcHNlIGZpbGw9IiNGNUY1RjUiIGN4PSIzMiIgY3k9IjMzIiByeD0iMzIiIHJ5PSI3Ii8+CiAgICA8ZyBmaWxsLXJ1bGU9Im5vbnplcm8iIHN0cm9rZT0iI0Q5RDlEOSI+CiAgICAgIDxwYXRoIGQ9Ik01NSAxMi43Nkw0NC44NTQgMS4yNThDNDQuMzY3LjQ3NCA0My42NTYgMCA0Mi45MDcgMEgyMS4wOTNjLS43NDkgMC0xLjQ2LjQ3NC0xLjk0NyAxLjI1N0w5IDEyLjc2MVYyMmg0NnYtOS4yNHoiLz4KICAgICAgPHBhdGggZD0iTTQxLjYxMyAxNS45MzFjMC0xLjYwNS45OTQtMi45MyAyLjIyNy0yLjkzMUg1NXYxOC4xMzdDNTUgMzMuMjYgNTMuNjggMzUgNTIuMDUgMzVoLTQwLjFDMTAuMzIgMzUgOSAzMy4yNTkgOSAzMS4xMzdWMTNoMTEuMTZjMS4yMzMgMCAyLjIyNyAxLjMyMyAyLjIyNyAyLjkyOHYuMDIyYzAgMS42MDUgMS4wMDUgMi45MDEgMi4yMzcgMi45MDFoMTQuNzUyYzEuMjMyIDAgMi4yMzctMS4zMDggMi4yMzctMi45MTN2LS4wMDd6IiBmaWxsPSIjRkFGQUZBIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"
                        alt=""></div>
                    <p class="avue-empty__desc">暂无数据</p>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <!-- <el-row type="flex"
                  :gutter="10">
            <div class="common-box w100">
              <div class="o-title border flex">
                <div>法律法规意识认识程度</div>
              </div>
              <div class="flex-one h220">
                <lawChar></lawChar>
              </div>
            </div>
          </el-row> -->
          <el-row :gutter="10" type="flex" justify="space-around" class="mt10" v-if="youngAnalysisData.criminalCnt!=undefined">
            <el-col :span="3" :md="8">
              <div class="common-box item flex static-item h110">
                <div class="item-circle">
                  <el-avatar :size="52" shape="square" fit="contain" :src="`/img/bg/icon11.jpg`"></el-avatar>
                </div>
                <div class="item ml20 flex-one">
                  <div class="fs24 c0 num-family">{{youngAnalysisData.salvageCnt}}</div>
                  <div class="c9 font-nowrap">救助件总数</div>
                </div>
              </div>
            </el-col>
            <el-col :span="3" :md="8">
              <div class="common-box item flex static-item h110">
                <div class="item-circle">
                  <el-avatar :size="52" shape="square" fit="contain" :src="`/img/bg/icon12.jpg`"></el-avatar>
                </div>
                <div class="item ml20 flex-one">
                  <div class="fs24 c0 num-family">{{youngAnalysisData.salvageUndoCnt}}</div>
                  <div class="c9 font-nowrap">救助在办件</div>
                </div>
              </div>
            </el-col>
            <el-col :span="3" :md="8">
              <div class="common-box item flex static-item h110">
                <div class="item-circle">
                  <el-avatar :size="52" shape="square" fit="contain" :src="`/img/bg/icon13.jpg`"></el-avatar>
                </div>
                <div class="item ml20 flex-one">
                  <div class="fs24 c0 num-family">{{youngAnalysisData.salvageDoneCnt}}</div>
                  <div class="c9 font-nowrap">救助完成件</div>
                </div>
              </div>
            </el-col>
            <el-col :span="3" :md="8">
              <div class="common-box item flex static-item h110">
                <div class="item-circle">
                  <el-avatar :size="52" shape="square" fit="contain" :src="`/img/bg/icon14.jpg`"></el-avatar>
                </div>
                <div class="item ml20 flex-one">
                  <div class="fs24 c0 num-family">{{youngAnalysisData.salvageSocialCnt}}</div>
                  <div class="c9 font-nowrap">社会救助人数</div>
                </div>
              </div>
            </el-col>
            <el-col :span="3" :md="8">
              <div class="common-box item flex static-item h110">
                <div class="item-circle">
                  <el-avatar :size="52" shape="square" fit="contain" :src="`/img/bg/icon15.jpg`"></el-avatar>
                </div>
                <div class="item ml20 flex-one">
                  <div class="fs24 c0 num-family">{{youngAnalysisData.salvageGuaranteeCnt}}</div>
                  <div class="c9 font-nowrap">最低保障救助人数</div>
                </div>
              </div>
            </el-col>
            <el-col :span="3" :md="8">
              <div class="common-box item flex static-item h110">
                <div class="item-circle">
                  <el-avatar :size="52" shape="square" fit="contain" :src="`/img/bg/icon16.jpg`"></el-avatar>
                </div>
                <div class="item ml20 flex-one">
                  <div class="fs24 c0 num-family">{{youngAnalysisData.salvageChildrenCnt}}</div>
                  <div class="c9 font-nowrap">失依儿童救助人数</div>
                </div>
              </div>
            </el-col>
            <el-col :span="3" :md="8">
              <div class="common-box item flex static-item h110">
                <div class="item-circle">
                  <el-avatar :size="52" shape="square" fit="contain" :src="`/img/bg/icon17.jpg`"></el-avatar>
                </div>
                <div class="item ml20 flex-one">
                  <div class="fs24 c0 num-family">{{youngAnalysisData.tattooCnt}}</div>
                  <div class="c9 font-nowrap">有纹身数量</div>
                </div>
              </div>
            </el-col>
            <el-col :span="3" :md="8">
              <div class="common-box item flex static-item h110">
                <div class="item-circle">
                  <el-avatar :size="52" shape="square" fit="contain" :src="`/img/bg/icon18.jpg`"></el-avatar>
                </div>
                <div class="item ml20 flex-one">
                  <div class="fs24 c0 num-family">{{youngAnalysisData.disciplinaryCnt}}</div>
                  <div class="c9 font-nowrap">在校处分量</div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="10" type="flex" justify="space-around">
            <el-col :span="3" :md="8">
              <div class="common-box item flex static-item h110">
                <div class="item-circle">
                  <el-avatar :size="52" shape="square" fit="contain" :src="`/img/bg/icon19.jpg`"></el-avatar>
                </div>
                <div class="item ml20 flex-one">
                  <div class="fs24 c0 num-family">{{youngAnalysisData.entertainmentCnt}}</div>
                  <div class="c9 font-nowrap">常出没于娱乐场所</div>
                </div>
              </div>
            </el-col>
            <el-col :span="3" :md="8">
              <div class="common-box item flex static-item h110">
                <div class="item-circle">
                  <el-avatar :size="52" shape="square" fit="contain" :src="`/img/bg/icon20.jpg`"></el-avatar>
                </div>
                <div class="item ml20 flex-one">
                  <div class="fs24 c0 num-family">{{youngAnalysisData.workTimeCnt}}</div>
                  <div class="c9 font-nowrap">作息时间不规律</div>
                </div>
              </div>
            </el-col>
            <el-col :span="3" :md="8">
              <div class="common-box item flex static-item h110">
                <div class="item-circle">
                  <el-avatar :size="52" shape="square" fit="contain" :src="`/img/bg/icon21.jpg`"></el-avatar>
                </div>
                <div class="item ml20 flex-one">
                  <div class="fs24 c0 num-family">{{youngAnalysisData.nightOutCnt}}</div>
                  <div class="c9 font-nowrap">有夜不归宿行为</div>
                </div>
              </div>
            </el-col>
            <el-col :span="3" :md="8">
              <div class="common-box item flex static-item h110">
                <div class="item-circle">
                  <el-avatar :size="52" shape="square" fit="contain" :src="`/img/bg/icon22.jpg`"></el-avatar>
                </div>
                <div class="item ml20 flex-one">
                  <div class="fs24 c0 num-family">{{youngAnalysisData.videoCnt}}</div>
                  <div class="c9 font-nowrap">有观看淫秽行为</div>
                </div>
              </div>
            </el-col>
            <el-col :span="3" :md="8">
              <div class="common-box item flex static-item h110">
                <div class="item-circle">
                  <el-avatar :size="52" shape="square" fit="contain" :src="`/img/bg/icon23.jpg`"></el-avatar>
                </div>
                <div class="item ml20 flex-one">
                  <div class="fs24 c0 num-family">{{youngAnalysisData.fightCnt}}</div>
                  <div class="c9 font-nowrap">有打架行为</div>
                </div>
              </div>
            </el-col>
            <el-col :span="3" :md="8">
              <div class="common-box item flex static-item h110">
                <div class="item-circle">
                  <el-avatar :size="52" shape="square" fit="contain" :src="`/img/bg/icon24.jpg`"></el-avatar>
                </div>
                <div class="item ml20 flex-one">
                  <div class="fs24 c0 num-family">{{youngAnalysisData.gameCnt}}</div>
                  <div class="c9 font-nowrap">喜欢网络游戏</div>
                </div>
              </div>
            </el-col>
            <el-col :span="3" :md="8">
              <div class="common-box item flex static-item h110">
                <div class="item-circle">
                  <el-avatar :size="52" shape="square" fit="contain" :src="`/img/bg/icon25.jpg`"></el-avatar>
                </div>
                <div class="item ml20 flex-one">
                  <div class="fs24 c0 num-family">{{youngAnalysisData.habitsCnt}}</div>
                  <div class="c9 font-nowrap">不良习惯人数</div>
                </div>
              </div>
            </el-col>
            <el-col :span="3" :md="8">
              <div class="common-box item flex static-item h110">
                <div class="item-circle">
                  <el-avatar :size="52" shape="square" fit="contain" :src="`/img/bg/icon26.jpg`"></el-avatar>
                </div>
                <div class="item ml20 flex-one">
                  <div class="fs24 c0 num-family">{{youngAnalysisData.criminalCnt}}</div>
                  <div class="c9 font-nowrap">犯罪前科数</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="index-box lv3-2-box mt20" style="width: 100%; padding-left: 0; padding-right: 0" ref="#anchor-5">
          <div class="o-title border flex" style="padding:10px 20px 20px">
            <div>工作信息统计</div>
            <div style="display: inline-flex;align-items: center;">
              <el-select class="yearOptionsClass" v-model="workInfoForAllYearValue" placeholder="请选择" @change="loadWorkInfoForAllDataWay">
                <el-option v-for="item in YearOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <div class="c9" @click="$router.push('/job/jobinformationList')">更多</div>
            </div>
          </div>
          <el-radio-group v-model="radio4" class="radio-checkbox" size="mini" @change="radio4Cut">
            <el-radio-button label="最新更新"></el-radio-button>
            <el-radio-button label="工作信息类型"></el-radio-button>
            <!-- <el-radio-button label="机构工作信息"></el-radio-button> -->
          </el-radio-group>
          <div class="df flex-one">
            <tjpie ref="tjpie" style="width: 100%"></tjpie>
          </div>
        </div>
      </div>
    </div>
  </ScaleBox>
</template>
<script>
import ScaleBox from "@/components/scale-box/index.vue";
import bar from "@/components/chart/bar.vue";
import jgbar from "@/components/chart/jgbar.vue";
import BaseLine1 from "@/components/chart/BaseLine1.vue";
import tjpie from "@/components/chart/tjpie.vue";
import { mapGetters } from "vuex";
import linechart from "@/components/chart/linechart.vue";
import linechart1 from "@/components/chart/linechart1.vue";
import circlechart from "@/components/chart/circlechart.vue";
import orderChart from "@/components/chart/orderChart.vue";
import agePieChart from "@/components/chart/agePieChart.vue";
import onlineChar from "@/components/chart/onlineChar.vue";
import timeChar from "@/components/chart/timeChar.vue";
import monthOrganChart from "@/components/chart/monthOrganChart.vue";
import monthOrganChart1 from "@/components/chart/monthOrganChart1.vue";
import caseTypeChat from "@/components/chart/caseTypeChat.vue";
import cultureChart from "@/components/chart/cultureChart.vue";
import sexChart from "@/components/chart/sexChart.vue";
import involvedPlaceChat from "@/components/chart/involvedPlaceChat.vue";
import involvedFamilyChat from "@/components/chart/involvedFamilyChat.vue";
import registerChart from "@/components/chart/registerChart.vue";
import lawChar from "@/components/chart/lawChar.vue";
import rescueRegionChar from "@/components/chart/rescueRegionChar.vue";
import fiveChart from "@/components/chart/fiveChart.vue";
import testChart from "@/components/chart/testChart.vue";
import {
  statisticalTopData, statisticsDataCnt, statisticsDataDone,
  workTypeData, planWorkTypeData, regionTypeData, monthTrendData,
  regionSalvageData, youngCrimeTypeData, crimeTimeData, lawRegulationsData,
  academicStageData, genderData, ageSalvageData,provinceData,placeTypeData,
  householdTypeData,youngAnalysisData,workInfoForLast7DaysData,workInfoForAllData
} from '@/api/statistical/index.js';
import { color } from "@/util/util";
export default {
  components: {
    bar,
    jgbar,
    BaseLine1,
    tjpie,
    linechart,
    linechart1,
    circlechart,
    orderChart,
    agePieChart,
    ScaleBox,
    onlineChar,
    timeChar,
    monthOrganChart,
    monthOrganChart1,
    caseTypeChat,
    cultureChart,
    sexChart,
    involvedPlaceChat,
    involvedFamilyChat,
    registerChart,
    lawChar,
    rescueRegionChar,
    fiveChart,
    testChart,
  },
  computed: {
    ...mapGetters(["isbig"]),
  },
  // computed: {
  // 计算属性的 getter
  // getRandom: function() {
  //     return function(min = 0, max = 100) {
  //         return Math.floor(Math.random() * (max - min) + min)
  //     }
  // },
  // getRandomColor: function() {
  //     let arr = []
  //     return function(min = 0, max = 100) {
  //         return Math.floor(Math.random() * (max - min) + min)
  //     }
  // }
  // },
  data() {
    return {
      statisticalTopData: {},
      orderIndex: 0,
      orderDateIndex: 0,
      radio1: "0",
      statisticsDate: "",
      breatheTyleData: {},
      radio4: "最新更新",
      status: "first",
      tableData: [{
        date: "2016-05-02",
        name: "D234231029431",
        name1: "精神慰藉-0",
        address: "xxxx机构",
        status: "进行中",
      },
      {
        date: "2016-05-02",
        name: "D234231029431",
        name1: "精神慰藉-0",
        address: "xxxx机构",
        status: "进行中",
      },
      {
        date: "2016-05-02",
        name: "D234231029431",
        name1: "精神慰藉-0",
        address: "xxxx机构",
        status: "进行中",
      },
      {
        date: "2016-05-02",
        name: "D234231029431",
        name1: "精神慰藉-0",
        address: "xxxx机构",
        status: "进行中",
      },
      ],
      workTypeData: {},
      youngAnalysisData:{},
      planWorkTypeData: {
        data: []
      },
      planWorkTypeShow: true,
      YearOptions: [{
        value: 2023,
        label: '2023年'
      }, {
        value: 2022,
        label: '2022年'
      }, {
        value: 2021,
        label: '2021年'
      },
      ],
      topYearValue: 2023,
      workTypeYearValue: 2023,
      planWorkTypeYearValue: 2023,
      regionTypeYearValue: 2023,
      monthTrendYearValue: 2023,
      regionSalvageYearValue: 2023,
      youngCrimeTypeYearValue: 2023,
      crimeTimeYearValue: 2023,
      crimeTimeIf:true,
      lawRegulationsYearValue: 2023,
      lawRegulationsIf:true,
      academicStageYearValue: 2023,
      academicStageIf: true,
      genderYearValue: 2023,
      genderIf: true,
      ageSalvageYearValue: 2023,
      ageSalvageIf: true,
      
      provinceYearValue: 2023,
      provinceIf: true,
      placeTypeYearValue: 2023,
      placeTypeIf: true,
      householdTypeYearValue: 2023,
      householdTypeIf: true,
      workInfoForAllYearValue:2023,
      YearValue: 2023,
      monthOptions: [
        {
          value: 1,
          label: '1月'
        },
        {
          value: 2,
          label: '2月'
        },
        {
          value: 3,
          label: '3月'
        },
        {
          value: 4,
          label: '4月'
        },
        {
          value: 5,
          label: '5月'
        },
        {
          value: 6,
          label: '6月'
        },
        {
          value: 7,
          label: '7月'
        },
        {
          value: 8,
          label: '8月'
        },
        {
          value: 9,
          label: '9月'
        },
        {
          value: 10,
          label: '10月'
        },
        {
          value: 11,
          label: '11月'
        },
        {
          value: 12,
          label: '12月'
        },
      ],
      monthValue: 1,
    };
  },
  mounted() {
    this.$refs['scoll-page'].addEventListener('scroll', this.handleScroll)
    //统计分析-头部信息
    this.loadStatisticalTopDataWay()
    // 统计数据-呼叫量
    this.loadStatisticsDataCntWay()
    // 统计分析-年份下拉框
    this.loadYearSelectDataWay();
    // 统计分析-呼叫类型统计
    this.loadWorkTypeDataWay();
    //统计分析-计划类型占比
    this.loadBreatheTyleDataWay();
    //统计分析-呼叫量趋势
    this.loadMonthTrendDataWay();
    //统计分析-救助分布数据
    this.loadRegionSalvageDataWay();
    //统计分析-查询涉案时间分布数据
    this.loadCrimeTimeDataWay();
    // 统计分析-查询法律意识认识统计数据
    this.loadLawRegulationsDataWay();
    // 统计分析-文化程度统计数据
    this.loadAcademicStageDataWay();
    // 统计分析-性别统计数据
    this.loadGenderDataWay();
    // 统计分析-救助涉案年龄统计数据
    this.loadAgeSalvageDataWay();
    // 统计分析-涉案青少年户籍所在地
    this.loadProvinceDataWay();
    //统计分析-五类青少年分布
    this.loadAdolescentKindDataWay();
    //统计分析-案件类型呼叫量统计数据
    this.loadYoungCrimeTypeDataWay();
    // 统计分析-涉案场所
    this.loadPlaceTypeDataWay();
    // 统计分析-涉案家庭类型
    this.loadHouseholdTypeDataWay();
    // 统计分析-青少年分析统计数据
    this.loadYoungAnalysisDataWay();
    // 统计分析-最新7天工作信息
    this.loadWorkInfoForLast7DaysDataWay();
    // 统计分析-工作信息类型
    // this.loadWorkInfoForAllDataWay();
  },
  methods: {
    //统计分析-头部信息
    loadStatisticalTopDataWay() {
      statisticalTopData({}).then((res) => {
        // console.log("头部信息",res.data.data);
        this.statisticalTopData = res.data.data;
      })
    },
    // 切换呼叫量/完成量
    clickOrderIndex(index) {
      if (this.orderIndex === index) {
        return;
      }
      this.orderIndex = index;
      if (this.orderIndex == 0) {
        this.loadStatisticsDataCntWay();
        return;
      }
      this.loadStatisticsDataDoneWay();
    },
    // 统计数据-呼叫量
    loadStatisticsDataCntWay() {
      statisticsDataCnt({
        year: this.topYearValue
      }).then((res) => {
        // console.log("统计数据/青少年分布-呼叫量", res.data.data);
        this.$refs.bar.setOptions(this.statisticsDataShift(res.data.data.region));//统计数据
        this.$refs.agePieChart.setOptions(this.agePieChartDataShift(res.data.data.age[0]));//涉案年龄段
      })
    },
    // 统计数据-完成量
    loadStatisticsDataDoneWay() {
      statisticsDataDone({
        year: this.topYearValue
      }).then((res) => {
        // console.log("统计数据/青少年分布-完成量", res.data.data);
        this.$refs.bar.setOptions(this.statisticsDataShift(res.data.data.region));//统计数据
        this.$refs.agePieChart.setOptions(this.agePieChartDataShift(res.data.data.age[0]));//涉案年龄段
      })
    },
    //统计数据-转换
    statisticsDataShift(data) {
      let temp = {}
      data.map((item) => {
        let cur = temp[item.regionCode]
        if (cur) {
          cur.data[item.month - 1] = item.cnt
        } else {
          cur = {
            name: item.regionName,
            code: item.regionCode,
            data: [
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
              0
            ]
          }
          cur.data[item.month - 1] = item.cnt
          temp[item.regionCode] = cur
        }
      })
      let seriesList = [];
      for (let key in temp) {
        seriesList.push(temp[key]);
      }
      return seriesList;
    },
    // 涉案年龄段-解析
    agePieChartDataShift(data) {
      let returnList = [
        { value: 20, name: "5-8岁" },
        { value: 10, name: "9-12岁" },
        { value: 105, name: "13-15岁" },
        { value: 20, name: "16-18岁" },
        { value: 20, name: "19-22岁" },
        { value: 10, name: "23-25岁" },
      ]
      returnList[0].value = data.age5;
      returnList[1].value = data.age9;
      returnList[2].value = data.age13;
      returnList[3].value = data.age16;
      returnList[4].value = data.age19;
      returnList[5].value = data.age23;
      return returnList;
    },
    // 年份下拉框数据
    loadYearSelectDataWay() {
      let date = new Date();
      this.topYearValue = date.getFullYear();
      let historyYear = 2021;//有数据的历史年份
      this.YearOptions = [];
      for (var i = this.topYearValue - historyYear; i >= 0; i--) {
        let yearList = {
          value: this.topYearValue - i,
          label: this.topYearValue - i + '年'
        };
        this.YearOptions.unshift(yearList);
      }
    },
    // 选择年份加载不同年的统计数据
    topYearValueWay() {
      if (this.orderIndex == 0) {
        this.loadStatisticsDataCntWay();
        return;
      }
      this.loadStatisticsDataDoneWay();
    },
    // 统计分析-呼叫类型统计
    loadWorkTypeDataWay() {
      workTypeData({
        year: this.workTypeYearValue
      }).then((res) => {
        console.log("统计分析-呼叫类型统计", res.data.data.workType)
        this.workTypeData = {};
        this.workTypeData.cntSum = 0;
        this.workTypeData.zhyz = 0;
        this.workTypeData.zhyzCnt = 0;
        this.workTypeData.szjd = 0;
        this.workTypeData.szjdCnt = 0;
        this.workTypeData.zzjz = 0;
        this.workTypeData.zzjzCnt = 0;
        if (res.data.data.workType == "") {
          return;
        }
        for (var index in res.data.data.workType) {
          this.workTypeData.cntSum += res.data.data.workType[index].cnt;
        }
        for (var key in res.data.data.workType) {
          switch (res.data.data.workType[key].dataTypeName) {
            case '综合援助':
              this.workTypeData.zhyz = res.data.data.workType[key].cnt / this.workTypeData.cntSum * 100;
              this.workTypeData.zhyz = this.workTypeData.zhyz.toFixed(2)
              this.workTypeData.zhyzCnt = res.data.data.workType[key].cnt;
              break;
            case '思政教导':
              this.workTypeData.szjd = res.data.data.workType[key].cnt / this.workTypeData.cntSum * 100;
              this.workTypeData.szjd = this.workTypeData.szjd.toFixed(2)
              this.workTypeData.szjdCnt = res.data.data.workType[key].cnt;
              break;
            case '政策救助':
              this.workTypeData.zzjz = res.data.data.workType[key].cnt / this.workTypeData.cntSum * 100;
              this.workTypeData.zzjz = this.workTypeData.zzjz.toFixed(2)
              this.workTypeData.zzjzCnt = res.data.data.workType[key].cnt;
              break;
          }
        }
        console.log("统计分析-呼叫类型统计", this.workTypeData)
      })
    },
    //统计分析-计划类型占比
    loadBreatheTyleDataWay() {
      planWorkTypeData({
        // breatheTyleData({
        year: this.planWorkTypeYearValue
      }).then((res) => {
        console.log("统计分析-计划类型占比", res.data.data)
        if (res.data.data.planWorkType == "") {
          this.planWorkTypeShow = false;
          return;
        }
        this.planWorkTypeShow = true;
        this.planWorkTypeData.data = res.data.data.planWorkType;
        this.planWorkTypeData.cntSum = 0;
        for (var index in res.data.data.planWorkType) {
          this.planWorkTypeData.cntSum += res.data.data.planWorkType[index].cnt;
        }
        for (var key in this.planWorkTypeData.data) {
          this.planWorkTypeData.data[key].cntSum = res.data.data.planWorkType[key].cnt
          this.planWorkTypeData.data[key].cnt = this.planWorkTypeData.data[key].cnt / this.planWorkTypeData.cntSum * 100;
          this.planWorkTypeData.data[key].cnt = this.planWorkTypeData.data[key].cnt.toFixed(2)
        }
        let _this = this;
        setTimeout(function () {
          if (_this.planWorkTypeData.data[0] != undefined) {
            _this.$refs.circlechart1.setOptions(_this.planWorkTypeData.data[0]);
          }
          if (_this.planWorkTypeData.data[1] != undefined) {
            _this.$refs.circlechart2.setOptions(_this.planWorkTypeData.data[1]);
          }
          if (_this.planWorkTypeData.data[2] != undefined) {
            _this.$refs.circlechart3.setOptions(_this.planWorkTypeData.data[2]);
          }
        }, 100);
        // console.log("统计分析-计划类型占比", _this.planWorkTypeData.data)
      })
    },
    //统计分析-呼叫量趋势
    loadMonthTrendDataWay() {
      monthTrendData({
        year: this.monthTrendYearValue
      }).then((res) => {
        // console.log("呼叫量趋势", res.data.data);
        let callVolumeTrendJson = {
          xAxisData: [
            '一月',
            '二月',
            '三月',
            '四月',
            '五月',
            '六月',
            '七月',
            '八月',
            '九月',
            '十月',
            '十一月',
            '十二月'
          ],
          seriesList: [
            {
              name: '完成数',
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,],
            },
            {
              name: '新增数',
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,],
            }
          ]
        }
        for (var key in res.data.data) {
          callVolumeTrendJson.seriesList[0].data[res.data.data[key].month - 1] = res.data.data[key].doneCnt;
          callVolumeTrendJson.seriesList[1].data[res.data.data[key].month - 1] = res.data.data[key].calledCnt;
        }
        this.$refs.linechart.setOptions(callVolumeTrendJson);
      })
    },
    // 统计分析-救助分布数据
    loadRegionSalvageDataWay() {
      regionSalvageData({
        year: this.regionSalvageYearValue
      }).then((res) => {
        // console.log("救助分布数据", res.data.data);
        let returnData = {
          xAxisData: [],
          seriesData: []
        }
        for (var key in res.data.data) {
          returnData.xAxisData.push(res.data.data[key].region_name);
          returnData.seriesData.push(res.data.data[key].cnt);
        }
        this.$refs.rescueRegionChar.setOptions(returnData);
      })
    },
    //统计分析-查询涉案时间分布数据
    loadCrimeTimeDataWay() {
      crimeTimeData({
        year: this.crimeTimeYearValue,
        month: this.monthValue,
      }).then((res) => {
        console.log("查询涉案时间分布数据", res.data.data);
        if(res.data.data==""){
          this.crimeTimeIf = false;
          return;
        }
        this.crimeTimeIf = true;
        let returnData = {
          xAxisData: [],
          seriesData: []
        }
        var d = new Date(this.regionTypeYearValue, this.monthValue, 0);
        for (var i = 1; i <= d.getDate(); i++) {
          let monthValueIndex;
          if(i<=9){
            monthValueIndex =this.monthValue + "-0" + i
            if(this.monthValue<=9){
              monthValueIndex ="0"+this.monthValue + "-0" + i
            }
          }else{
            monthValueIndex =this.monthValue + "-" + i
            if(this.monthValue<=9){
              monthValueIndex ="0"+this.monthValue + "-" + i
            }
          }
          returnData.xAxisData.push(this.monthValue + "-" + i);
          for(var key in res.data.data){
            if(res.data.data[key].dateStr === monthValueIndex){
              returnData.seriesData.push(res.data.data[key].cnt);
              break;
            }
            if(key == (res.data.data.length-1)){
              returnData.seriesData.push(0);
            }
          }
        }
        console.log("查询涉案时间分布数据", returnData);
        let _this = this;
        setTimeout(function () {
          _this.$refs.timeChar.setOptions(returnData);
        }, 100);
      })
    },
    // 统计分析-查询法律意识认识统计数据
    loadLawRegulationsDataWay() {
      lawRegulationsData({
        year: this.lawRegulationsYearValue
      }).then((res) => {
        if(res.data.data==""){
          this.lawRegulationsIf= false;
          return;
        }
        this.lawRegulationsIf= true;
        let seriesData = [];
        for (var key in res.data.data) {
          let pushData = { value: 0, name: "" };
          pushData.value = res.data.data[key].cnt;
          pushData.name = res.data.data[key].dataTypeName;
          if (pushData.name == "") {
            pushData.name = "未知"
          }
          seriesData.push(pushData);
        }
        // console.log("查询法律意识认识统计数据", seriesData);
        var _this = this;
        setTimeout(function () {
          _this.$refs.monthOrganChart1.setOptions(seriesData);
        }, 100);
        
      })
    },
    // 统计分析-文化程度统计数据
    loadAcademicStageDataWay() {
      academicStageData({
        year: this.academicStageYearValue
      }).then((res) => {
        // console.log("文化程度统计数据", res.data.data);
        if(res.data.data==""){
          this.academicStageIf= false;
          return;
        }
        this.academicStageIf= true;
        let seriesData = [];
        for (var key in res.data.data) {
          let pushData = { value: 0, name: "" };
          pushData.value = res.data.data[key].cnt;
          pushData.name = res.data.data[key].dataTypeName;
          if (pushData.name == "") {
            pushData.name = "未知"
          }
          seriesData.push(pushData);
        }
        // console.log("文化程度统计数据", seriesData);
        var _this = this;
        setTimeout(function () {
          _this.$refs.cultureChart.setOptions(seriesData);
        }, 100);
      })
    },
    // 统计分析-性别统计数据
    loadGenderDataWay() {
      genderData({
        year: this.genderYearValue
      }).then((res) => {
        // console.log("性别统计数据", res.data.data);
        if(res.data.data==""){
          this.genderIf= false;
          return;
        }
        this.genderIf= true;
        let seriesData = [];
        for (var key in res.data.data) {
          let pushData = { value: 0, name: "" };
          pushData.value = res.data.data[key].cnt;
          pushData.name = res.data.data[key].dataTypeName;
          seriesData.push(pushData);
        }
        // console.log("性别统计数据", seriesData);
        var _this = this;
        setTimeout(function () {
          _this.$refs.sexChart.setOptions(seriesData);
        }, 100);
      })
    },
    // 统计分析-救助年龄分布
    loadAgeSalvageDataWay() {
      ageSalvageData({
        year: this.ageSalvageYearValue
      }).then((res) => {
        if(res.data.data==""){
          this.ageSalvageIf= false;
          return;
        }
        this.ageSalvageIf= true;
        console.log("救助年龄分布", res.data.data);
        var _this = this;
        setTimeout(function () {
          _this.$refs.agePieChart2.setOptions(_this.agePieChartDataShift(res.data.data[0]));//救助年龄分布
        }, 100);
      })
    },
    // 统计分析-涉案青少年户籍所在地
    loadProvinceDataWay(){
      provinceData({
        year: this.provinceYearValue
      }).then((res) => {
        // console.log("涉案青少年户籍所在地", res.data.data);
        // return;
        if(res.data.data==""){
          this.provinceIf= false;
          return;
        }
        this.provinceIf= true;
        let seriesData = [];
        for (var key in res.data.data) {
          let pushData = { value: 0, name: "" };
          pushData.value = res.data.data[key].cnt;
          pushData.name = res.data.data[key].data_type;
          seriesData.push(pushData);
        }
        // console.log("涉案青少年户籍所在地", seriesData);
        var _this = this;
        setTimeout(function () {
          _this.$refs.registerChart.setOptions(seriesData);
        }, 100);
      })
    },
    //统计分析-五类青少年分布
    loadAdolescentKindDataWay() {
      regionTypeData({
        year: this.regionTypeYearValue
      }).then((res) => {
        this.$refs.fiveChart.setOptions(this.adolescentKindDataShift(res.data.data));
      })
    },
    // 统计分析-案件类型呼叫量统计数据
    loadYoungCrimeTypeDataWay() {
      youngCrimeTypeData({
        year: this.youngCrimeTypeYearValue
      }).then((res) => {
        // console.log("案件类型呼叫量统计数据", res.data.data);
        let returnData = {
          xAxisData: [],
          seriesData: []
        }
        for (var key in res.data.data) {
          returnData.xAxisData.push(res.data.data[key].crimeTypeName);
          returnData.seriesData.push(res.data.data[key].cnt);
        }
        this.$refs.caseTypeChat.setOptions(returnData);
      })
    },
    //五类青少年分布-转换
    adolescentKindDataShift(data) {
      let temp = {}
      let dataTypeList = []
      data.map((item) => {
        let cur = temp[item.regionCode]
        dataTypeList[item.dataType - 1] = item.dataTypeName;
        if (cur) {
          cur.data[item.dataType - 1] = item.cnt
        } else {
          cur = {
            name: item.regionName,
            code: item.regionCode,
            data: []
          }
          cur.data[item.dataType - 1] = item.cnt
          temp[item.regionCode] = cur
        }

      })
      let seriesList = {
        temp: temp,
        dataTypeList: dataTypeList
      };
      return seriesList;
    },
    // 统计分析-涉案场所
    loadPlaceTypeDataWay(){
      placeTypeData({
        year: this.placeTypeYearValue
      }).then((res) => {
        // console.log("涉案场所", res.data.data);
        let returnData = {
          xAxisData: [],
          seriesData: []
        }
        for (var key in res.data.data) {
          if(res.data.data[key].dataTypeName==""){
            returnData.xAxisData.push("未知");
          }else{
            returnData.xAxisData.push(res.data.data[key].dataTypeName);
          }
          returnData.seriesData.push(res.data.data[key].cnt);
        }
        this.$refs.involvedPlaceChat.setOptions(returnData);
      })
    },
    // 统计分析-涉案家庭类型
    loadHouseholdTypeDataWay(){
      householdTypeData({
        year: this.householdTypeYearValue
      }).then((res) => {
        // console.log("涉案家庭类型", res.data.data);
        let returnData = {
          xAxisData: [],
          seriesData: []
        }
        for (var key in res.data.data) {
          if(res.data.data[key].dataTypeName==""){
            returnData.xAxisData.push("未知");
          }else{
            returnData.xAxisData.push(res.data.data[key].dataTypeName);
          }
          returnData.seriesData.push(res.data.data[key].cnt);
        }
        this.$refs.involvedFamilyChat.setOptions(returnData);
      })
    },
    // 统计分析-青少年分析统计数据
    loadYoungAnalysisDataWay(){
      youngAnalysisData({}).then((res) => {
        this.youngAnalysisData = res.data.data;
        // console.log("青少年分析统计数据", res.data.data);
      })
    },
    // 统计分析-最新7天工作信息
    loadWorkInfoForLast7DaysDataWay(){
      workInfoForLast7DaysData({}).then((res) => {
        let tjpieData = {
          sum:0,
          data:[],
        };
        for(var key1 in res.data.data){
          tjpieData.sum+=res.data.data[key1].cnt;
        }
        for(var key in res.data.data){
          let returnData;
          if(key<=5){
            returnData = { value: res.data.data[key].cnt,
              proportion:res.data.data[key].cnt/tjpieData.sum*100,
              name: res.data.data[key].dataTypeName, itemStyle: { color: color[key] }};
              returnData.proportion = returnData.proportion.toFixed(2)
          }else if(key>5||key<=10){
            returnData = { value: res.data.data[key].cnt,
              proportion:res.data.data[key].cnt/tjpieData.sum*100,
              name: res.data.data[key].dataTypeName, itemStyle: { color: color[key-5] }};
              returnData.proportion = returnData.proportion.toFixed(2)
          }else{
            returnData = { value: res.data.data[key].cnt,
              proportion:res.data.data[key].cnt/tjpieData.sum*100,
              name: res.data.data[key].dataTypeName, itemStyle: { color: color[key-10] }};
              returnData.proportion = returnData.proportion.toFixed(2)
          }
          tjpieData.data.push(returnData);
        }
        console.log("最新7天工作信息", tjpieData);
        this.$refs.tjpie.setOptions(tjpieData);
      })
    },
    // 统计分析-工作信息类型
    loadWorkInfoForAllDataWay(){
      this.radio4 = "工作信息类型";
      workInfoForAllData({
        year: this.workInfoForAllYearValue
      }).then((res) => {
        let tjpieData = {
          sum:0,
          data:[],
        };
        for(var key1 in res.data.data){
          tjpieData.sum+=res.data.data[key1].cnt;
        }
        for(var key in res.data.data){
          let returnData;
          if(key<=5){
            returnData = { value: res.data.data[key].cnt,
              proportion:res.data.data[key].cnt/tjpieData.sum*100,
              name: res.data.data[key].dataTypeName, itemStyle: { color: color[key] }};
              returnData.proportion = returnData.proportion.toFixed(2)
          }else if(key>5||key<=10){
            returnData = { value: res.data.data[key].cnt,
              proportion:res.data.data[key].cnt/tjpieData.sum*100,
              name: res.data.data[key].dataTypeName, itemStyle: { color: color[key-5] }};
              returnData.proportion = returnData.proportion.toFixed(2)
          }else{
            returnData = { value: res.data.data[key].cnt,
              proportion:res.data.data[key].cnt/tjpieData.sum*100,
              name: res.data.data[key].dataTypeName, itemStyle: { color: color[key-10] }};
              returnData.proportion = returnData.proportion.toFixed(2)
          }
          tjpieData.data.push(returnData);
        }
        console.log("工作信息类型", tjpieData);
        this.$refs.tjpie.setOptions(tjpieData);
      })
    },
    radio4Cut(){
      if(this.radio4 == "最新更新"){
        this.loadWorkInfoForLast7DaysDataWay();
      }else if(this.radio4 == "工作信息类型"){
        this.loadWorkInfoForAllDataWay();
      }
    },
    handleScroll() {
      var scrollTop = this.$refs['scoll-page'].scrollTop
      for (let i = 1; i <= 5; i++) {
        if (scrollTop >= this.$refs['#anchor-' + i].offsetTop - 58) {
          this.radio1 = i
        }
      }
    },
    //锚点跳转
    goAnchor(val) {
      this.radio1 = val;
      this.$refs['scoll-page'].scrollTo(0, this.$refs['#anchor-' + val].offsetTop - 58)
    }
  }
};

</script>
<style lang="scss" scoped>
@import "@/styles/index.scss";
@import "@/styles/moudles/desk.scss";
@import "@/styles/moudles/order.scss";
</style>
<style lang="scss" scoped="scoped">
.console-wrapper {
  .console-item {
    display: flex;

    .item {
      flex: 1;
      color: #999;

      .num {
        margin-top: 10px;
        font-size: 30px;
        color: #333;
      }
    }
  }

  .map-echart {
    height: 700px;
  }

  .line-echart-box {
    height: 220px;
  }

  .line-chart-box2 {
    height: 130px;
  }

  .dashboard-chart {
    height: 250px;
  }

  .wave-chart-box {
    height: 250px;
  }

  .hot-label-wrapper {
    position: relative;
    // height: 200px;
  }
}

.font-nowrap {
  //   white-space: nowrap;
}

.h220 {
  display: flex;
  height: 220px;
}

.yearOptionsClass {
  width: 100px;
  margin-right: 10px;
}

.monthOptionsClass {
  width: 80px;
  margin-right: 10px;
}

.border {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
